// import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate'
// import createPersistedState from 'vuex-persistedstate'

import userStore from "@/store/modules/userStore.js";
import devStore from "@/store/modules/devStore.js";
import devApiStore from "@/store/modules/devApiStore.js";
import testStore from "@/store/modules/testStore.js";
import workflowStore from '@/store/modules/workflow/workflowStore.js'
import axiosRequest from "@/store/modules/axiosRequest.js";

import s3Image from "@/store/modules/s3Image.js";

// import Urls from '@/common/urls'
// import Apiroot from '@/common/apiroot'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // login 관련
    loginList: [],
    devList: [],
    // loginSuccess : false,
    // loginError : false,
    // userEmail : null,

    // dev 관련
    menuType: "",

    backdrop: false,
  },
  mutations: {
    // loginSuccess(state, {email}){
    //   console.log('mutation', this.email);
    //   state.loginSuccess = true
    //   state.userEmail = email
    // },
    // loginError(state, {email}){
    //   state.loginError = true
    //   state.userEmail = email
    // }
  },
  actions: {
    //   async login({commit}, {email, password}) {
    //     try {
    //       console.log('store : ',commit,  email , password)
    //         const result = await axios.post(Apiroot.company + Urls.register,
    //         { userInfo :
    //           {
    //             code : '1', email : email, password : password, pwdCheck : password
    //           }
    //         },
    //         {
    //           headers:
    //           {
    //             "Content-Type": 'application/json',
    //           }
    //         });
    //         // alert(result)
    //         console.log(result)
    //         if (result.status == 200) {
    //           if(result.data['code'] == 0){
    //               alert("ddddddddddd", email)
    //               this.loginSuccess = true
    //               this.userEmail = result.data.userInfo.email
    //               console.log(this.userEmail);
    //               commit('loginSuccess', {
    //                 email: email
    //               });
    //           // commit('loginSuccess', {user});
    //           } else {
    //             alert('아이디나 비밀번호가 틀립니다')
    //           }
    //         }
    //       } catch (err) {
    //       alert("mmmmmmmmmmm")
    //         commit('loginError', {
    //           userEmail: email
    //         });
    //         throw new Error(err)
    //     }
    // }
  },
  getters: {

    // isLoggedIn: state => state.loginSuccess,
    // hasLoginErrored: state => state.loginError,
  },
  modules: {
    userStore: userStore,
    devStore: devStore,
    devApiStore: devApiStore,
    workflowStore: workflowStore,
    testStore: testStore,
    s3Image: s3Image,
    axiosRequest: axiosRequest,
  },
  plugins : [createPersistedState()]
});
